import { markProgrammaticReload } from '../../../services/analytics/pageLoad';

const CHUNK_LOAD_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|ChunkLoadError/i;

export const isChunkLoadError = (error: unknown): boolean => {
  if (!error) return false;
  const message = error instanceof Error ? error.message : String(error);
  const name = error instanceof Error ? error.name : '';
  return name === 'ChunkLoadError' || CHUNK_LOAD_ERROR_PATTERN.test(message);
};

const CHUNK_RELOAD_KEY = 'chunkReloadAt';
const CHUNK_RELOAD_WINDOW_MS = 10000;

export const reloadOnceForChunkError = (error: unknown): boolean => {
  if (!isChunkLoadError(error)) return false;
  try {
    const last = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0);
    if (Date.now() - last <= CHUNK_RELOAD_WINDOW_MS) return false;
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    // sessionStorage unavailable; fall through to a single reload attempt
  }
  markProgrammaticReload('chunk_load_error');
  window.location.reload();
  return true;
};
